// Find out what portion sizes are available via the
// returned recipe macros objects
import { APIRecipeNutrition } from '@mindfulchefuk/features/Recipes/interfaces'

interface availablePortionsByMacrosParams {
  macrosLookup: {
    [key: number]: APIRecipeNutrition
  }
  portionSizes: number[]
}

const availablePortionsByMacros = ({
  macrosLookup,
  portionSizes,
}: availablePortionsByMacrosParams): number[] =>
  portionSizes.filter((portion) => {
    const portionMacros = macrosLookup[portion]
    if (!portionMacros) return false
    return portion
  })

export default availablePortionsByMacros
